/**
 * Source names that Hookdeck's own surfaces send to `POST /sources/new`.
 *
 * That endpoint validates `name` against ALIAS_PATTERN (`/^[A-z0-9-_]+$/`), so every name
 * here has to satisfy it. They live in `domain/` so the server can assert, in its own test
 * suite, that the create endpoint still accepts what its first-party clients send.
 *
 * This exists because it did not. The Outpost onboarding hardcoded `'Outpost onboarding
 * test'` in the dashboard; when `POST /sources/new` started validating names, the spaces
 * made every call a 422, and the "Create your first destination" step served a spinner for
 * 15 days. The server tests were green throughout — they asserted the new rule correctly,
 * and nothing connected that rule to its only real caller.
 *
 * Adding a name here is what makes it covered. A name used against this endpoint but
 * declared inline somewhere else has no test holding the contract open for it.
 */

/** Test URL provisioned by the Outpost `/get-started` "Create your first destination" step. */
export const OUTPOST_ONBOARDING_SOURCE_NAME = 'outpost-onboarding-test';

/** Every first-party name, for the contract test over `POST /sources/new`. */
export const PLATFORM_CONSOLE_SOURCE_NAMES = [OUTPOST_ONBOARDING_SOURCE_NAME] as const;
